export default "__VITE_ASSET__D4CQQK4K__"